import { SUCCESS_SUFFIX, FAILURE_SUFFIX } from 'core/actions/apis';

const rootActionPath = 'core/TrendingStores';

export const TRENDING_STORES_GET_SUCCESS = `${rootActionPath}/GET_${SUCCESS_SUFFIX}`;
export const TRENDING_STORES_GET_FAILURE = `${rootActionPath}/GET_${FAILURE_SUFFIX}`;

export const TRENDING_STORES_STORE_DY_DATA = `${rootActionPath}/STORE_DY_DATA`;
